import { render, staticRenderFns } from "./RightMenuIcon.vue?vue&type=template&id=50f37fa6&scoped=true&"
import script from "./RightMenuIcon.vue?vue&type=script&lang=js&"
export * from "./RightMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f37fa6",
  null
  
)

export default component.exports